export const step3 = {
    eva: {
      title: 'sessions.create.wizard.step3.title'
    },
    mylivetv: {
      title: 'sessions.create.wizard.step3.title_won'
    }
};



// WEBPACK FOOTER //
// ./src/app/modules/sessions/create/step/step3.ts